import { createFileRoute, redirect } from '@tanstack/react-router';

// Contact detail moved out of the settings drawer to the top-level Contacts
// surface. This pre-existing settings URL redirects to its top-level equivalent,
// preserving the contactId param AND the incoming search (e.g. focus=missing for
// the inline-resolve deep-link) so deep-links keep working.
export const Route = createFileRoute('/admin/finance/settings/contacts/$contactId')({
  beforeLoad: ({
    params,
    search,
  }: {
    params: { contactId: string };
    search: Record<string, unknown>;
  }) => {
    throw redirect({
      to: '/admin/finance/contacts/$contactId',
      params: { contactId: params.contactId },
      search,
    });
  },
});
